import { c as _c } from "react/compiler-runtime";
export const MeteoraLogo = t0 => {
  const $ = _c(14);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect fill="white" height="44" width="44" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#clip0_8358_5275)">{t2}<g clipPath="url(#clip1_8358_5275)"><path d="M31.4982 14.2277C31.9831 13.7429 32.7344 13.7721 33.0449 14.2855C33.3806 14.8367 33.6344 15.4325 33.815 16.0566C33.9162 16.4113 33.7989 16.8261 33.5046 17.1208L24.0075 26.6179C23.4339 27.1915 22.7204 27.588 21.963 27.7496L21.1743 27.9173C20.4201 28.0821 19.7002 28.4786 19.1298 29.049L11.8384 36.3404C11.5279 35.1426 11.3917 34.3342 12.3646 33.3613L31.4982 14.2277ZM33.5558 18.32C33.8725 18.0033 34.3594 18.1863 34.328 18.6043C34.1315 21.1648 32.9117 23.8624 30.7378 26.0362C29.0803 27.852 24.4029 30.6277 21.06 32.4877C20.3756 32.8676 19.8183 32.0563 20.3792 31.4955L33.5525 18.3233L33.5558 18.32ZM29.1847 10.3881C29.4856 10.0872 29.9294 10.0234 30.2336 10.2324C30.8672 10.6633 31.4597 11.2876 31.764 12.0416C31.878 12.3331 31.7801 12.691 31.5298 12.9413L21.3007 23.1715C20.7273 23.7448 20.0143 24.1405 19.2573 24.3022L18.4676 24.4699C17.7135 24.6347 16.9945 25.0313 16.4242 25.6016L10.1142 31.9105C9.80378 30.7129 9.95316 29.6198 10.9257 28.6471L29.1847 10.3881ZM24.8494 8.56911C25.4197 7.99887 26.2375 7.77676 26.9092 8.02994C27.3307 8.19155 27.737 8.38898 28.1205 8.62031C28.6271 8.92468 28.6523 9.66569 28.177 10.1409L18.8227 19.4953C18.2871 20.0309 17.5581 20.3161 16.8609 20.2654C16.129 20.2116 15.3586 20.513 14.7914 21.0801L9.66758 26.204C9.35707 25.0061 9.76003 23.6596 10.7329 22.6867L12.3929 21.0257L24.8494 8.56911ZM23.3518 7.6596C23.8014 7.65357 23.9757 8.18884 23.6339 8.53099L14.7195 17.4454L13.6891 18.4747L12.1206 20.0432L12.1118 20.053C11.7823 20.3826 11.2941 20.0847 11.4779 19.6663L13.0116 16.1807C13.0971 15.9684 13.1924 15.7524 13.2969 15.5337L13.3057 15.5119C14.1898 13.6391 15.613 11.6524 16.9503 10.3152C19.0956 8.16983 21.0226 7.68178 23.3518 7.6596Z" fill="url(#paint0_linear_8358_5275)" /></g></g>;
    t4 = <path d="M22 0.5C33.8741 0.5 43.5 10.1259 43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5Z" stroke="white" strokeOpacity="0.08" />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_8358_5275" x1="38.9472" x2="14.2337" y1="7.69373" y2="36.2688"><stop stopColor="#F5BD00" /><stop offset="0.364891" stopColor="#F54B00" /><stop offset="1" stopColor="#6E45FF" /></linearGradient>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <clipPath id="clip0_8358_5275"><path d="M0 22C0 9.84974 9.84974 0 22 0V0C34.1503 0 44 9.84974 44 22V22C44 34.1503 34.1503 44 22 44V44C9.84974 44 0 34.1503 0 22V22Z" fill="white" /></clipPath>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <defs>{t5}{t6}<clipPath id="clip1_8358_5275"><rect fill="white" height="29" transform="translate(8.61548 7.5)" width="26.7692" /></clipPath></defs>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== className || $[11] !== rest || $[12] !== size) {
    t8 = <svg aria-label="Meteora" className={className} fill="none" height={size} viewBox="0 0 44 44" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}{t4}{t7}</svg>;
    $[10] = className;
    $[11] = rest;
    $[12] = size;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};